import { useClaimRewardsDialog } from './logic/useClaimRewardsDialog'
import { ClaimRewardsView } from './views/ClaimRewardsView'
import { SuccessView } from './views/SuccessView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { withSuspense } from '@/ui/utils/withSuspense'

export interface ClaimRewardsDialogContentContainerProps {
  closeDialog: () => void
}

function ClaimRewardsDialogContentContainer({ closeDialog }: ClaimRewardsDialogContentContainerProps) {
  const { pageStatus, rewardsToClaim, actionsViewState } = useClaimRewardsDialog()

  if (pageStatus.state === 'success') {
    return <SuccessView claimedRewards={rewardsToClaim} onClose={closeDialog} />
  }

  return <ClaimRewardsView actionsViewState={actionsViewState} rewards={rewardsToClaim} />
}

const ClaimRewardsDialogContentContainerWithSuspense = withSuspense(
  ClaimRewardsDialogContentContainer,
  DialogContentSkeleton,
)
export { ClaimRewardsDialogContentContainerWithSuspense as ClaimRewardsDialogContentContainer }
